const state = {
  miscNotifications: [],
  pauseNotifications: [],
};

export default state;
